import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { rupiah, num, formatTanggal } from '../lib/format';
import { Trash } from '@phosphor-icons/react';
import { toast } from 'sonner';

const TYPE_LABEL = { purchase: 'Pembelian', production: 'Produksi', sale: 'Penjualan' };
const TYPE_TONE = {
  purchase: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
  production: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
  sale: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300',
};

const describe = (t) => {
  if (t.type === 'purchase') return `${t.material_nama} · ${num(t.qty_kemasan, 2)} kemasan (+${num(t.tambahan_stok, 2)} ${t.satuan})`;
  if (t.type === 'production') return `${t.product_nama} · ${num(t.kali_produksi, 2)}x resep → ${num(t.hasil_units, 2)} unit`;
  return `${t.product_nama} · ${num(t.qty, 2)} × ${rupiah(t.harga_per_unit)} (potongan ${t.potongan_persen}%)`;
};

const amount = (t) => {
  if (t.type === 'purchase') return <span className="text-rose-600">− {rupiah(t.total_harga)}</span>;
  if (t.type === 'sale') return <span className="text-emerald-600 dark:text-emerald-400">+ {rupiah(t.laba_total)} <span className="text-xs text-muted-foreground">laba</span></span>;
  return <span className="text-muted-foreground">—</span>;
};

export default function Riwayat() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState('all');
  const [confirmDel, setConfirmDel] = useState(null);

  const load = async () => {
    const r = await api.get('/transactions');
    setItems(r.data);
  };
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (confirmDel !== id) { setConfirmDel(id); setTimeout(() => setConfirmDel(null), 3000); return; }
    await api.delete(`/transactions/${id}`);
    toast.success('Transaksi dihapus');
    setConfirmDel(null);
    load();
  };

  const shown = filter === 'all' ? items : items.filter((t) => t.type === filter);

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-2">
        {[['all', 'Semua'], ['purchase', 'Pembelian'], ['production', 'Produksi'], ['sale', 'Penjualan']].map(([k, l]) => (
          <button key={k} onClick={() => setFilter(k)} data-testid={`filter-${k}`}
            className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors ${filter === k ? 'bg-primary text-primary-foreground border-primary' : 'border-border hover:bg-secondary'}`}>
            {l}
          </button>
        ))}
      </div>
      <p className="text-xs text-muted-foreground">Klik ikon hapus 2x untuk konfirmasi. Menghapus riwayat tidak mengembalikan stok.</p>

      <div className="bg-card border border-border/60 rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="table-transactions">
            <thead className="bg-secondary/50 text-left">
              <tr>
                <th className="p-3 font-semibold">Tanggal</th>
                <th className="p-3 font-semibold">Jenis</th>
                <th className="p-3 font-semibold">Keterangan</th>
                <th className="p-3 font-semibold text-right">Nilai</th>
                <th className="p-3 font-semibold text-right">Aksi</th>
              </tr>
            </thead>
            <tbody>
              {shown.length === 0 && <tr><td colSpan="5" className="p-8 text-center text-muted-foreground">Belum ada transaksi.</td></tr>}
              {shown.map((t) => (
                <tr key={t.id} className="border-t border-border/60">
                  <td className="p-3 whitespace-nowrap">{formatTanggal(t.tanggal)}</td>
                  <td className="p-3"><span className={`px-2 py-1 rounded-md text-xs font-medium ${TYPE_TONE[t.type]}`}>{TYPE_LABEL[t.type]}</span></td>
                  <td className="p-3">
                    {describe(t)}
                    {t.type === 'sale' && <span className="ml-2 text-xs px-1.5 py-0.5 rounded bg-secondary text-muted-foreground" data-testid={`tx-saluran-${t.id}`}>{t.saluran || 'Lainnya'}</span>}
                    {t.catatan && <div className="text-xs text-muted-foreground">{t.catatan}</div>}
                  </td>
                  <td className="p-3 text-right tabular-nums whitespace-nowrap">{amount(t)}</td>
                  <td className="p-3 text-right">
                    <button onClick={() => del(t.id)} data-testid={`btn-del-tx-${t.id}`}
                      className={`px-2.5 py-1.5 rounded-lg text-xs inline-flex items-center gap-1 ${confirmDel === t.id ? 'bg-rose-600 text-white' : 'text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-900/20'}`}>
                      <Trash size={16} /> {confirmDel === t.id ? 'Yakin?' : ''}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
